import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';
import { hasRestrictedRole } from 'globalutils/fmUtils';
import { ROLES } from 'globalconfig/constants/keys';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ isEdit }) => {
  return {
    form_setModalListObject: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => !isEdit,
      default: () => false,
    },
    schema_layout_provider: {
      [SERVICE_PROVIDERS.CLUTCH]: () => true,
      default: () => false,
    },
    render_trailerType_disabled: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_wlId_disabled: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_vin_disabled: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_year_disabled: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_make_disabled: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_model_disabled: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => hasRestrictedRole([ROLES.FLMANAGER]),
      default: () => false,
    },
    render_wlId_showhidden: {
      [SERVICE_PROVIDERS.RISK_THEORY]: () => true,
      default: () => false,
    },
    render_nextMaintenanceDate_showhidden: {
      [SERVICE_PROVIDERS.CLUTCH]: () => false,
      [SERVICE_PROVIDERS.RISK_THEORY]: () => false,
      [SERVICE_PROVIDERS.WEBFLEET]: () => false,
      default: () => true,
    },
    render_trackingDevice_showhidden: {
      [SERVICE_PROVIDERS.PATRIOT]: () => true,
      default: () => false,
    },
    render_rightwrapper_showhidden: {
      [SERVICE_PROVIDERS.SIMPLEX]: () => false,
      default: () => true,
    },
    render_inspectionForm_disabled: {
      [SERVICE_PROVIDERS.WEBFLEET]: () => true,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
